import { FC } from "react";
import { IconProps } from "./types";

export const InfoCircleIcon: FC<IconProps> = ({
  fill = "currentColor",
  width = 17,
  height = 16,
  className,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <g clipPath="url(#n83yltl42a)">
      <path
        d="M8.5 0a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm-.167 3a.833.833 0 1 1 0 1.667.833.833 0 0 1 0-1.667zm.917 9.667h-1.5a.667.667 0 0 1 0-1.334h.083V7.167H7.75a.667.667 0 0 1 0-1.334h.75c.368 0 .667.299.667.667v4.833h.083a.667.667 0 0 1 0 1.334z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="n83yltl42a">
        <path fill={fill} transform="translate(.5)" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
